// eslint-disable-next-line no-restricted-imports
import { Dropdown } from 'semantic-ui-react';

/* eslint-disable i18next/no-literal-string -- language names are shown in their own language */
export const LANGUAGE_OPTIONS = [
  { key: 'en', value: 'en', text: 'English' },
  { key: 'es', value: 'es', text: 'Español' },
];
/* eslint-enable i18next/no-literal-string */

const LanguagePicker = ({ ...rest }) => {
  return <Dropdown options={LANGUAGE_OPTIONS} selectOnBlur={false} clearable={false} {...rest} />;
};

export default LanguagePicker;
